module.exports = __webpack_public_path__ + "media/images/country_flags/ph-5fcf792450e423eba4eda8ccdb11ecf3.png";